import { render } from "./PentagonDrawing.vue?vue&type=template&id=0f0353d6&scoped=true"
import script from "./PentagonDrawing.vue?vue&type=script&lang=js"
export * from "./PentagonDrawing.vue?vue&type=script&lang=js"

import "./PentagonDrawing.vue?vue&type=style&index=0&id=0f0353d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0353d6"]])

export default __exports__